import requestAction from '../../utils/requestAction'

export const fetchPeople = (params: string = "") =>
  requestAction('PERSON_LIST', params)(`people`, 'GET')

export const fetchAllPeople = () =>
  fetchPeople('?all=true')

export const checkEmailExists = (email: string, id: number | undefined | null, handleResponse?: (exists: boolean) => void) =>
  requestAction('PERSON_CHECK', `?email=${encodeURIComponent(email)}${id ? `&personId=${id}` : ''}`)(
    'check-email', 'GET',
    undefined,
    undefined,
    undefined,
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response.exists) })

